import { z } from 'zod';

export const CogniteFunctionType = z.object({
  id: z.number().int().min(1).max(9007199254740991).describe('A server-generated ID for the object.'),
  createdTime: z.coerce.date().describe('The creation time of the function.'),
  name: z.string().min(1).max(140).describe('The name of the function.'),
  externalId: z
    .string()
    .max(255)
    .optional()
    .describe('The external ID provided by the client. Must be unique for the resource type.'),
  fileId: z
    .number()
    .int()
    .min(1)
    .max(9007199254740991)
    .describe("The file ID to a file uploaded to Cognite's Files API."),
  owner: z.string().max(128).optional().describe('Owner of this function. Typically used to know who created it.'),
  description: z.string().max(500).optional().describe('Description of the function.'),
  metadata: z
    .record(z.string(), z.string())
    .optional()
    .describe('Custom, application specific metadata. String key -> String value.'),
  secrets: z.record(z.string(), z.string()).optional().describe('Object with additional secrets as key/value pairs.'),
  functionPath: z
    .string()
    .max(500)
    .optional()
    .describe('Relative path from the root folder to the file containing the handle function.'),
  environmentVariables: z
    .record(z.string(), z.string())
    .optional()
    .describe('Object with environment variables as key/value pairs.'),
  cpu: z.number().optional().describe('Number of CPU cores per function.'),
  memory: z.number().optional().describe('Memory per function measured in GB.'),
  runtime: z.enum(['py310', 'py311', 'py312']).default('py312').describe('The runtime of the function.'),
  runtimeVersion: z
    .string()
    .optional()
    .describe('The complete specification of the function runtime with major, minor and patch version numbers.'),
});

export type CogniteFunctionType = z.infer<typeof CogniteFunctionType>;
